module.exports = __webpack_public_path__ + "static/media/SM-ST1-TRIAL.e940c855.mp3";